import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import win10StartDarkBackground from './assets/win10-start-dark-bgimage.svg';
import { getStartStyles } from './styles/win10-start-dark-style';


export const Win10StartDark = ({
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getStartStyles({ styleOverrides }));

  return (
    <div className={classnames('win-start-background', classes.startBackground)}>
      <img className={classnames('win-start-background-image', classes.background)} alt="" src={win10StartDarkBackground} />
      <div className={classnames('win-start-ad-container', classes.adContainer)} />
    </div>
  );
};

Win10StartDark.propTypes = {
  styleOverrides: PropTypes.shape({}),
};

Win10StartDark.defaultProps = {
  styleOverrides: {},
};
